import React from "react";

import ViewerStyle from '../../css/Viewer.module.css';

// "Regresar", which leaves a group: drawn like the buttons that open one
// (the owner's request of 2026-10-13).
export default function BackButton(props) {
    const { onClick } = props;
    return (
        <div className={`${ViewerStyle["btn-month"]} ${ViewerStyle["btn-group"]}`} onClick={onClick}>
            <ion-icon name="arrow-back-outline" />
            <span>Regresar</span>
        </div>
    );
}
